const CompatibilityScore = () => import(/* webpackChunkName 'CompatibilityScore' */ '@/components/Astrology/CompatibilityScore/CompatibilityScoreList/CompatibilityScoreList.vue');

export default {
    path: 'compatibility-score-description',
    name: 'Compatibility Score',
    meta: {
        label: 'Compatibility Score'
    },
    component: CompatibilityScore
};